import React from 'react';
import { Text } from '@shopify/polaris';
import { VerticalSpace } from './VerticalSpace';

const HeadSection = ({ title, subtitle }) => {
  return (
    <>
      <Text variant="headingLg" as="h2" text-align="center">
        {title}
      </Text>
      {subtitle && (
        <>
          <VerticalSpace size="x-small" />
          <Text variant="bodyMd" as="p">
            {subtitle}
          </Text>
        </>
      )}
      <VerticalSpace size="small" />
      <hr />
    </>
  );
};

export default HeadSection;
